import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ControlAssessmentComponent } from './control-assessment.component';

const routes: Routes = [{
  path: '',
  component: ControlAssessmentComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ControlAssessmentRoutingModule { }
